import "./App.css";
import React, { useEffect, useState } from "react";
import ImageGalleryComponent from "./components/ImageGallery";
import Navbar from "./components/NavBar";
import imageList from "./imageList.json";

const App = () => {
  const [imageStatus, setImageStatus] = useState({});
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedSubfolders, setSelectedSubfolders] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [bigScreen, setBigScreen] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  const [hasWomenFilter, setHasWomenFilter] = useState(false);  

  const toggleHasWomenFilter = () => {
    setHasWomenFilter((prev) => !prev);  
  };
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  useEffect(() => {
    const checkBigScreen = () => {
      setBigScreen(window.innerWidth > 1500);
    };

    checkBigScreen();

    window.addEventListener("resize", checkBigScreen);

    return () => {
      window.removeEventListener("resize", checkBigScreen);
    };
  }, []);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);
  const flattenedImageList = Object.keys(imageList).flatMap((country) =>
    Object.keys(imageList[country]).flatMap((subfolder) =>
      imageList[country][subfolder]
        .filter((image) => {
          const thumbnailSrc = `/${country}/${subfolder}/thumbnails/${image.thumbnail}`;
          return imageStatus[thumbnailSrc] !== "error";
        })
        .map((image) => ({
          country,
          subfolder,
          original: `/${country}/${subfolder}/${image.full}`,
          thumbnail: `/${country}/${subfolder}/thumbnails/${image.thumbnail}`,
          has_women: image.has_women,  
        }))
    )
  );
  
  const countries = Object.keys(imageList);
  const subfolders = [
    ...new Set(
      Object.values(imageList).flatMap((country) => Object.keys(country))
    ),
  ];
  

  const toggleSelection = (type, value, clearAll = false) => {
    if (clearAll) {
      if (type === "country") {
        setSelectedCountries([]);
      } else {
        setSelectedSubfolders([]);
      }
    } else {
      if (type === "country") {
        setSelectedCountries((prev) =>
          prev.includes(value)
            ? prev.filter((c) => c !== value)
            : [...prev, value]
        );
      } else {
        setSelectedSubfolders((prev) =>
          prev.includes(value)
            ? prev.filter((s) => s !== value)
            : [...prev, value]
        );
      }
    }
  };

  return (
    <div className={`app-container ${theme}`}>
      <Navbar
        countries={countries}
        toggleSelection={toggleSelection}
        selectedCountries={selectedCountries}
        toggleTheme={toggleTheme}
        theme={theme}
        setTheme={setTheme}
      />

      <ImageGalleryComponent
        flattenedImageList={flattenedImageList}
        selectedSubfolders={selectedSubfolders}
        subfolders={subfolders}
        countries={countries}
        toggleSelection={toggleSelection}
        selectedCountries={selectedCountries}
        theme={theme}
        isMobile={isMobile}
        bigScreen={bigScreen}
        hasWomenFilter={hasWomenFilter}
        setHasWomenFilter={setHasWomenFilter}
        toggleHasWomenFilter={toggleHasWomenFilter}
      />
    </div>
  );
};

export default App;
